import React from 'react'
import LinkPage from '../LinkPage';
export const rendercont = (item) => {
  return <LinkPage item = {item}/>
}
